<template>
    <div>
      <div class="row justify-content-between align-items-center">
        <div class="col-md-6 customHeading">
          <h3>{{moduleName}}</h3>
        </div>

        <!--==========Class dropdown============-->
      <div class="col-md-2">
        <b-form-select v-model="selectedStatus" :options="statusOptions" class = "class-dropdown"  @change="getCompanies()"></b-form-select>
      </div>

        <!---SEARCH BOX-->
         <div class="col-md-3">
          <div class="searchbox input-group" role="group">
          <input class="form-control search-box my-search-box" type="text" placeholder="Name" aria-label="search" v-model="filteredText">
         
          <button class="search-button btn btn-primary filter"  @click="getCompanies()"><i class="fa fa-search search-icon"></i></button>
          </div>
          
        </div>
        <div class="col-md-1 Add-button" style="text-align:center">
          <a href="javascript:void(0)">
            <div class="AddButton">
              <div class="icon">
                <i class="fas fa-arrow-alt-circle-right fa-1x" style="color: rgb(255, 50, 55);">
                </i>
              </div>
              <div data-text="Add" class="name add-btn" v-b-modal.AddCompanyModal>Add </div>
            </div>
          </a>
        </div> 


        <!--
        <div class="col-md-6"><div class="icons_group"><div class="row w3-center"><div class="col-md-2"><a href="#filterSection" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="filterSection"><div class="icon"><i class="fas fa-align-center fa-1x" style="color: rgb(243, 0, 104);"></i></div> <div data-text="Filter" class="name">Filter</div></a></div> <div class="col-md-3"><a href="#"><div class="icon"><i class="fas fa-check-circle fa-1x" style="color: rgb(149, 171, 184);"></i></div> <div data-text="Anti-Spam" class="name">Anti-Spam</div></a></div> <div class="col-md-3"><a href="#"><div class="icon"><i class="fas fa-stream fa-1x" style="color: rgb(255, 143, 38);"></i></div> <div data-target="Autoresponder" class="name">
                                  Auto-responder
        </div></a></div> <div class="col-md-2"><a href="#"><div class="icon"><i class="fas fa-arrow-alt-circle-right fa-1x" style="color: rgb(255, 50, 55);"></i></div> <div data-text="Forward" class="name">Forward</div></a></div> <div class="col-md-2"><a href="#"><div class="icon"><i class="fas fa-trash fa-1x" style="color: rgb(195, 0, 0);"></i></div> <div data-text="delete" class="name">Delete</div></a></div></div></div></div>
       
       --> 
       </div>
       <div class="row">
         <div class="col">
          <hr color="#CACACA" style="border-top: 2px solid rgb(202, 202, 202); margin-top: 5px;">
         </div>
        </div>
      <div>
        <div class="row"><div class="col">
        <table class="table table-striped table-borderless cutom-table table-striped table-sm" 
          style="font-size: 85%;">
            <thead>
              <tr>
             
                <th role="columnheader">Company/Person Name</th>
                <th role = "columnheader"> Status </th>
                <th role="columnheader" >Actions</th>
              </tr>
            </thead>
            <tbody>
              <!--IF STUDENTS ARRAY HAS NO VALUE THEN SHOW WITHOUT SHOWING DATA-->
              <tr v-if= "companies==null" >
                <td colspan="2">No Data</td>
              </tr>
              
            <tr v-else v-for="company in companies" :key=company.id>
              <td  role="cell" style="text-decoration: underline;">
                <router-link :to="{ name: 'companies', params: { company } }">
                      {{company.companyName}}
                </router-link>
              </td>
           
             <td>
               {{company.isActive ? "Active":"InActive"}}
             </td>
              <td>
                <span @click= "assignRights(company.id)">
                  <i role="button" title ="Assign Rights" style="color:green" class="fa fa-plus"></i>&nbsp;|&nbsp;
                </span>
                <span @click= "passRecordToEdit(company)">
                  <i role="button" style="color:green" class="far fa-edit"></i>&nbsp;|&nbsp;
                </span>
                <span @click= "passRecordToDelete(company.id)">
                  <i role="button" style="color:green" class="far fa-trash-alt"></i>&nbsp;|&nbsp;
                </span>
                <span @click= "passRecordToUnDelete(company.id)">
                  <i role="button" title = "Activate" style="color:green" class="fas fa-undo"></i>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div></div>

      

    <!--PAGINATION START-->
    <div class="row justify-content-between align-items-center">
      <div class="col-md-2">
        <div class="showPages">
          <select class="form-control" id="selClass" v-model="perPage" 
          @change="getCompanies()">
            <option v-for="option in options" :key="option.value" :value="option.value">
            {{option.text}}
            </option>
          </select>
        </div>
      </div>

      <div class="col-md-8 d-flex justify-content-center">
        <div class="overflow-auto">
            <b-pagination
              v-model= "page"
              :total-rows= rows
              :per-page="perPage"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              @change="getPage"
            ></b-pagination>
          </div>
      </div>

       <div class="col-md-2">
        <input class="form-control search-box page-no-search" type="text" v-bind:placeholder="page" aria-label="search" v-model.number="pageNumOnSearch" style="height:38px">
      
        <button class="search-button btn btn-primary search page-no-search-btn" @click="search()">
              GO
        </button>

       </div>
    </div>
    <!--/PAGINATION END-->	
    <!--SPINNER-->	
    <Spinner v-if="companies==null" message="Loading..." size="medium" 
      line-fg-color="rgb(222 224 219" 
      line-bg-color="rgb(68 66 62)">
    </Spinner>
    <!--/SPINNER-->	
      </div>
      <AddCompanyModal />
    <DeleteModal :msgForModal= "msgForModal" :apiEndPoint = "apiEndPoint" :heading = "deleteModalHeading"  :entityId = "companyToDelete"/>
    <AssignRightsModal  :companyId = "companyId"/>
    <b-modal style="padding:15px" size="lg" id="EditCompanyModal" ref="modal" title="Edit Company" ok-title="Submit" cancel-title="Close" 
      @hidden= "resetModal()" @show= "updateModal()" @ok= "handleOk" :ok-disabled = "this.$refs.EditCompanyForm != undefined ? !this.$refs.EditCompanyForm.checkValidity() : true">
        <form ref="EditCompanyForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
            <div class="col-md-4">
              <!--NAME INPUT-->
              <b-form-group label="Company Name" label-for="companyname-input" autocomplete="off">
                <b-form-input id="companyname-input" v-model= "CompanyName" required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
               <b-form-group  label="Address" label-for="address-input" autocomplete="off">
                <b-form-input id="address-input" v-model= "Address"  required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group  label="Phone" label-for="phone-input" autocomplete="off">
                <b-form-input id="phone-input" v-model= "PhoneNumber"  required></b-form-input>
              </b-form-group>
            </div>
          </div>     
        </form>
      </b-modal>
     
  </div>
</template>

<script>
import axios from 'axios';
// import config from '../config.js';
import Spinner from 'vue-simple-spinner'
import AddCompanyModal from '../../modals/AddCompanyModal'
import DeleteModal from '../../modals/DeleteModal'
import AssignRightsModal from '../../modals/AssignRightsModal'

export default {
    name: 'Users',
    data(){
        return{
          moduleName:'Companies',
          Id:null,
          CompanyName:'',
          Address:null,
          PhoneNumber:null,
          
          companyId:null,
          companyToEdit :  null,
          companyToDelete:null,
          msgForModal:null,
          apiEndPoint:null,
          deleteModalHeading:null,
          statusOptions:
          [
            { value: 0, text: 'All' },
            { value: 1, text: 'Active' },
            { value: 2, text: 'InActive' }
          ],
         
         
          companies:null,
          selectedStatus:1,
          pageNumOnSearch:'',
          filteredText:'',
          rows:0,
           page: 1,
          options: [
            { text: 'Show 2',  value: 2 },
            { text: 'Show 10',  value: 10 },
            { text: 'Show 25',  value: 25 },
            { text: 'Show 50',  value: 50 },
            { text: 'Show 100', value: 100 }
          ],
          perPage:25
        
		}
  },
 
methods:{
    getPage(page)
  {
    this.page = page;
    this.getCompanies();
  },
  passRecordToUnDelete(id)
  {
    this.companyToDelete = id;
    this.msgForModal = "Confirm to Reactive !";
    this.apiEndPoint = "company/Activate/";
    this.deleteModalHeading = "Reactive the company"
    this.$bvModal.show('DeleteModal')
  },
  assignRights(compId)
  {
    console.log("companyID"+compId)
    this.companyId = compId;
    console.log(this.companyId)
    setTimeout(
      () => {
    this.$bvModal.show('AssignRightsModal');
  },100)
    
  },
  
   editCompany(){ 
        
     axios.post('/company/Edit', 
      {"Id":this.Id, "CompanyName":this.CompanyName,"Address":this.Address, "PhoneNumber":this.PhoneNumber
      })
      .then(res=>{
            if(res.data.status == 1)
            {
                this.$bvModal.msgBoxOk('Company has been Edited successfully!', {
                title: 'Confirmation',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
                //  this.$router.go();

                this.getCompanies();
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },
   checkFormValidity() {
        const valid = this.$refs.EditCompanyForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
     
      resetModal() {
        this.CompanyName='';
        this.Id = '';
        this.PhoneNumber = '';
        this.Address = '';
        
       
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.editCompany()
       
        this.$nextTick(() => {
          //this.$router.go('/phones')
          this.$bvModal.hide('EditCompanyModal')
        
        })
      },
   updateModal()
  {
      console.log(this.companyToEdit)
        this.CompanyName= this.companyToEdit.companyName;
        this.Id = this.companyToEdit.id;
        this.PhoneNumber = this.companyToEdit.phoneNumber;
        this.Address = this.companyToEdit.address;
      
    },
  passRecordToDelete(id)
  {
    this.companyToDelete = id;
    this.msgForModal = "Confirm to delete !";
    this.apiEndPoint = "company/Delete/";
    this.deleteModalHeading = "Delete Company"
    this.$bvModal.show('DeleteModal')

  },
  passRecordToEdit(comp)
  {
    this.companyToEdit = comp;
   
    this.$bvModal.show('EditCompanyModal')
    
    // console.log(this.companyToEdit)
  },
    getCompanies(){
      axios.post('/company/getall',{"UserId":this.$auth.user().id,"ActiveInActive":this.selectedStatus,
      "PageSize":this.perPage,"Page":this.page,"Text":this.filteredText})
    .then(res=>{
      console.log('abccc')
      this.companies=res.data.data;
      this.rows = res.data.totalRecords;
    });
    },
		
   

  search(){
   
    this.page=this.pageNumOnSearch;
    this.getCompanies();
  }
  },
	created(){
    this.getCompanies();
    // this.getStudents();
    //localStorage.setItem("mytime", Date.now());
  },
  components:{
    Spinner,
    AddCompanyModal,
    DeleteModal,
    AssignRightsModal
   
  },
  
}
</script>

<style scoped>
button.page-link {
	display: inline-block;
}
button.page-link {
    font-size: 20px;
    color: #29b3ed;
    font-weight: 500;
}
.offset{
  width: 500px !important;
  margin: 20px auto;  
}
select#class-dropdown{
    width: 80%;
    margin-left: 16%
}
.row{
  margin-left:0px;
  margin-right:0px;
}
.col{
  padding-left:0px;
  padding-right:0px;
}
</style>